import { Component } from "@/types/types"
import { cx } from "@/utils/cx"
import { AccountCircleIcon as AccountCircleIconSm } from "../_icons/20x20/AccountCircleIcon"
import { AchievementIcon as AchievementIconSm } from "../_icons/20x20/AchivementIcon"
import { CalendarIcon as CalendarIconSm } from "../_icons/20x20/CalendarIcon"
import { CloseIcon as CloseIconSm } from "../_icons/20x20/CloseIcon"
import { ExternalLinkIcon as ExternalLinkIconSm } from "../_icons/20x20/ExternalLinkIcon"
import { FlagIcon as FlagIconSm } from "../_icons/20x20/FlagIcon"
import { LockIcon as LockIconSm } from "../_icons/20x20/LockIcon"
import { PowerIcon as PowerIconSm } from "../_icons/20x20/PowerIcon"
import { TextSnippetIcon as TextSnippetIconSm } from "../_icons/20x20/TextSnippetIcon"
import { VisibilityIcon as VisibilityIconSm } from "../_icons/20x20/VisibilityIcon"
import { VisibilityOffIcon as VisibilityOffIconSm } from "../_icons/20x20/VisibilityOffIcon"
import { ArrowLeftIcon as ArrowLeftIconSm } from "../_icons/20x20/ArrowLeftIcon"
import { QuizQuestionIcon as QuizQuestionIconSm } from "../_icons/20x20/QuizQuestionIcon"
import { RosetteIcon as RosetteIconSm } from "../_icons/20x20/RosetteIcon"
import { ListAddIcon as ListAddIconSm } from "../_icons/20x20/ListAddIcon"
import { ObjectIcon as ObjectIconSm } from "../_icons/20x20/ObjectIcon"
import { SearchIcon as SearchIconSm } from "../_icons/20x20/SearchIcon"

import { AIIcon as AIIconMd } from "../_icons/24x24/AIIcon"
import { ArrowLeftIcon as ArrowLeftIconMd } from "../_icons/24x24/ArrowLeftIcon"
import { BookmarkCheckIcon as BookmarkCheckIconMd } from "../_icons/24x24/BookmarkCheckIcon"
import { BookmarkFilledIcon as BookmarkFilledIconMd } from "../_icons/24x24/BookmarkFilledIcon"
import { BookmarkIcon as BookmarkIconMd } from "../_icons/24x24/BookmarkIcon"
import { BookmarkMinusFilledIcon as BookmarkMinusFilledIconMd } from "../_icons/24x24/BookmarkMinusFilledIcon"
import { BookmarkPlusIcon as BookmarkPlusIconMd } from "../_icons/24x24/BookmarkPlusIcon"
import { CampaignIcon as CampaignIconMd } from "../_icons/24x24/CampaignIcon"
import { ChatFilledIcon as ChatFilledIconMd } from "../_icons/24x24/ChatFilledIcon"
import { ChatIcon as ChatIconMd } from "../_icons/24x24/ChatIcon"
import { CheckCircleFilledIcon as CheckCircleFilledIconMd } from "../_icons/24x24/CheckCircleFilledIcon"
import { CheckCircleIcon as CheckCircleIconMd } from "../_icons/24x24/CheckCircleIcon"
import { ErrorCircleIcon as ErrorCircleIconMd } from "../_icons/24x24/ErrorCircleIcon"
import { Forward10Icon as Forward10IconMd } from "../_icons/24x24/Forward10Icon"
import { InfoCircleIcon as InfoCircleIconMd } from "../_icons/24x24/InfoCircleIcon"
import { OpenBookIcon as OpenBookIconMd } from "../_icons/24x24/OpenBookIcon"
import { Playback50Icon as Playback50IconMd } from "../_icons/24x24/Playback50Icon"
import { Playback75Icon as Playback75IconMd } from "../_icons/24x24/Playback75Icon"
import { Playback100Icon as Playback100IconMd } from "../_icons/24x24/Playback100Icon"
import { Playback125Icon as Playback125IconMd } from "../_icons/24x24/Playback125Icon"
import { Playback150Icon as Playback150IconMd } from "../_icons/24x24/Playback150Icon"
import { Playback175Icon as Playback175IconMd } from "../_icons/24x24/Playback175Icon"
import { Playback200Icon as Playback200IconMd } from "../_icons/24x24/Playback200Icon"
import { PlayCircleFilledIcon as PlayCircleFilledIconMd } from "../_icons/24x24/PlayCircleFilledIcon"
import { PlayCircleIcon as PlayCircleIconMd } from "../_icons/24x24/PlayCircleIcon"
import { PlayDisabledIcon as PlayDisabledIconMd } from "../_icons/24x24/PlayDisabledIcon"
import { PauseCircleFilled as PauseCircleFilledMd } from "../_icons/24x24/PauseCircleFilled"
import { Replay10Icon as Replay10IconMd } from "../_icons/24x24/Replay10Icon"
import { SignPostIcon as SignPostIconMd } from "../_icons/24x24/SignPostIcon"
import { TerminalIcon as TerminalIconMd } from "../_icons/24x24/TerminalIcon"
import { TextCardIcon as TextCardIconMd } from "../_icons/24x24/TextCardIcon"
import { VideoIcon as VideoIconMd } from "../_icons/24x24/VideoIcon"
import { WarningIcon as WarningIconMd } from "../_icons/24x24/WarningIcon"
import { WifiOffIcon as WifiOffIconMd } from "../_icons/24x24/WifiOffIcon"
import { SpinnerIcon as SpinnerIconMd } from "../_icons/24x24/SpinnerIcon"
import { ChevronRightIcon as ChevronRightIconMd } from "../_icons/24x24/ChevronRightIcon"
import { MoreHorizontalIcon as MoreHorizontalIconMd } from "../_icons/24x24/MoreHorizontalIcon"

import { BookIcon as BookIconLg } from "../_icons/32x32/BookIcon"
import { NewChatIcon as NewChatIconMd } from "../_icons/32x32/NewChat"
import { ChatIcon as ChatIconLg } from "../_icons/32x32/ChatIcon"
import { TerminalIcon as TerminalIconLg } from "../_icons/32x32/TerminalIcon"
import { CodeIcon as CodeIconLg } from "../_icons/32x32/CodeIcon"
import { HelpIcon as HelpIconLg } from "../_icons/32x32/HelpIcon"
import { UserIcon as UserIconLg } from "../_icons/32x32/UserIcon"

import { QuoteIcon as QuoteIconLg } from "../_icons/48x48/Quote"
import { CheckCircleFilledIcon as CheckCircleFilledIconLg } from "../_icons/48x48/CheckCircleFilledIcon"
import { LockFilledIcon as LockFilledIconLg } from "../_icons/48x48/LockFilledIcon"
import { ProfileFilledIcon as ProfileFilledIconLg } from "../_icons/48x48/ProfileFilledIcon"
import { CheckIcon as CheckIconLg } from "../_icons/48x48/Check"
import { CampaignIcon as CampaignIconLg } from "../_icons/48x48/CampaignIcon"
import { CodeOffIcon as CodeOffIconLg } from "../_icons/48x48/CodeOffIcon"
import { MenuIcon as MenuIconLg } from "../_icons/48x48/MenuIcon"

import { WarningIcon as WarningIconXl } from "../_icons/80x80/WarningIcon"
import { SearchListIcon as SearchListIconXl } from "../_icons/80x80/SearchList"
import { CheckCircleIcon as CheckCircleIconXl } from "../_icons/80x80/CheckCircleIcon"

export const COMPONENT_NAME = "icon"

export const presets = {
  name: {
    accountCircleSm: AccountCircleIconSm,
    achievementSm: AchievementIconSm,
    arrowLeftSm: ArrowLeftIconSm,
    calendarSm: CalendarIconSm,
    closeSm: CloseIconSm,
    externalLinkSm: ExternalLinkIconSm,
    flagSm: FlagIconSm,
    lockSm: LockIconSm,
    powerSm: PowerIconSm,
    quizQuestionSm: QuizQuestionIconSm,
    textSnippetSm: TextSnippetIconSm,
    visibilitySm: VisibilityIconSm,
    visibilityOffSm: VisibilityOffIconSm,
    rosetteSm: RosetteIconSm,
    listAddSm: ListAddIconSm,
    objectSm: ObjectIconSm,
    searchSm: SearchIconSm,

    aIMd: AIIconMd,
    arrowLeftMd: ArrowLeftIconMd,
    bookmarkCheckMd: BookmarkCheckIconMd,
    bookmarkFilledMd: BookmarkFilledIconMd,
    bookmarkMd: BookmarkIconMd,
    bookmarkMinusFilledMd: BookmarkMinusFilledIconMd,
    bookmarkPlusMd: BookmarkPlusIconMd,
    campaignMd: CampaignIconMd,
    chatFilledMd: ChatFilledIconMd,
    chatMd: ChatIconMd,
    checkCircleFilledMd: CheckCircleFilledIconMd,
    checkCircleMd: CheckCircleIconMd,
    errorCircleMd: ErrorCircleIconMd,
    forward10Md: Forward10IconMd,
    infoCircleMd: InfoCircleIconMd,
    openBookMd: OpenBookIconMd,
    playPauseFilledMd: PauseCircleFilledMd,
    playback50Md: Playback50IconMd,
    playback75Md: Playback75IconMd,
    playback100Md: Playback100IconMd,
    playback125Md: Playback125IconMd,
    playback150Md: Playback150IconMd,
    playback175Md: Playback175IconMd,
    playback200Md: Playback200IconMd,
    playCircleFilledMd: PlayCircleFilledIconMd,
    playCircleMd: PlayCircleIconMd,
    playDisabledMd: PlayDisabledIconMd,
    replay10Md: Replay10IconMd,
    signPostMd: SignPostIconMd,
    terminalMd: TerminalIconMd,
    textCardMd: TextCardIconMd,
    videoMd: VideoIconMd,
    warningMd: WarningIconMd,
    wifiOffMd: WifiOffIconMd,
    spinnerMd: SpinnerIconMd,
    newChatMd: NewChatIconMd,
    chevronRightMd: ChevronRightIconMd,
    moreHorizontalMd: MoreHorizontalIconMd,

    checkCircleFilledLg: CheckCircleFilledIconLg,
    lockFilledLg: LockFilledIconLg,
    profileFilledLg: ProfileFilledIconLg,
    checkLg: CheckIconLg,
    campaignLg: CampaignIconLg,
    codeOffLg: CodeOffIconLg,
    menuLg: MenuIconLg,
    quoteLg: QuoteIconLg,
    bookLg: BookIconLg,
    chatLg: ChatIconLg,
    codeLg: CodeIconLg,
    helpLg: HelpIconLg,
    terminalLg: TerminalIconLg,
    userLg: UserIconLg,

    warningXl: WarningIconXl,
    searchListXl: SearchListIconXl,
    checkCircleXl: CheckCircleIconXl,
  },
}

export type IconName = keyof typeof presets.name

export interface Props extends Component {
  name: IconName
}

export function Icon({ name, className, testId = COMPONENT_NAME }: Props) {
  const ResolvedIcon = presets.name[name]

  return <ResolvedIcon className={cx(``, className)} data-test={testId} />
}
